import { makeResetStyles, makeStyles, mergeClasses } from '@fluentui/react-components';
import { tokens, typographyStyles } from '@fluentui-copilot/tokens';
import type { ReferenceOverflowButtonSlots, ReferenceOverflowButtonState } from './ReferenceOverflowButton.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const referenceOverflowButtonClassNames: SlotClassNames<ReferenceOverflowButtonSlots> = {
  root: 'fai-ReferenceOverflowButton',
};

/**
 * Styles for the root slot
 */
const useRootBaseClassName = makeResetStyles({
  alignItems: 'center',
  backgroundColor: tokens.colorNeutralBackground3,
  border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
  borderRadius: tokens.borderRadiusMedium,
  color: tokens.colorNeutralForeground2,
  cursor: 'pointer',
  display: 'inline-flex',
  justifyContent: 'center',
  minHeight: '24px',
  padding: `${tokens.spacingVerticalXXS} ${tokens.spacingHorizontalS}`,
  ...typographyStyles.caption1,

  ':hover': {
    backgroundColor: tokens.colorNeutralBackground3Hover,
    borderColor: tokens.colorNeutralStroke1Hover,
    color: tokens.colorNeutralForeground2Hover,
  },

  ':hover:active': {
    backgroundColor: tokens.colorNeutralBackground3Pressed,
    borderColor: tokens.colorNeutralStroke1Pressed,
    color: tokens.colorNeutralForeground2Pressed,
  },
});

const useNextStyles = makeStyles({ root: { borderRadius: tokens.borderRadiusXLarge } });

/**
 * Apply styling to the ReferenceOverflowButton slots based on the state
 */
export const useReferenceOverflowButtonStyles_unstable = (
  state: ReferenceOverflowButtonState,
): ReferenceOverflowButtonState => {
  'use no memo';

  const { designVersion } = state;

  const rootBaseClassName = useRootBaseClassName();
  const nextStyles = useNextStyles();

  state.root.className = mergeClasses(
    referenceOverflowButtonClassNames.root,
    rootBaseClassName,
    designVersion === 'next' && nextStyles.root,
    state.root.className,
  );

  return state;
};
